(()=>{
  if(window.__NC_UNIVERSAL_ROUTER_V12)return;
  window.__NC_UNIVERSAL_ROUTER_V12=1;

  const handle=decodeURIComponent(
    (location.pathname.match(/\/products\/([^/?#]+)/)||[])[1]||''
  );

  const me=
    document.currentScript||
    [...document.scripts].find(
      s=>(s.src||'').includes('nc-universal-configurator.js')
    );

  const own=(me?.src||'').split('?')[0];

  const load=(name,v)=>{
    if(!own)return;

    const s=document.createElement('script');

    s.src=
      own.replace(
        'nc-universal-configurator.js',
        name
      )+`?v=${v}`;

    s.async=false;
    document.head.appendChild(s);
  };

  if(/^adore-/i.test(handle)){
    load(
      'nc-adore-configurator.js',
      '20260824-2105'
    );
  }

  else if(/skybedd/i.test(handle)){
    load(
      'nc-skybedd-configurator.js',
      '20260903-V12-MOLTON-IMAGE'
    );
  }

else{
  load(
    'nc-universal-configurator-base-v4.js',
    '20260903-V13-UITVERKOCHT-KLEUR'
  );
}
})();